<template>
  <base-page>
    <titlu-pagina Titlu="Consimtamant" :AdaugaVisible="false"></titlu-pagina>
    <div class="editor">
      <VueEditor v-model="Continut" />
      <div class="btn-group">
        <el-button type="success" class="buton" @click="save()"
          >Salveaza</el-button
        >
      </div>
    </div>
  </base-page>
</template>

<script>
import settings from "../../backend/LocalSettings";
import BasePage from "../../pages/Admin/BasePage";
import TitluPagina from "../../widgets/TitluPagina";
import { VueEditor } from "vue2-editor";

export default {
  name: "dashboard",
  extends: BasePage,
  components: {
    VueEditor,
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {
      Continut: "",
    };
  },
  methods: {
    save: async function() {
        if (this.Continut === "" || this.Continut === null) {
            this.$message.error('Consimtamantul este gol');
        } else {
            // console.log(this.Continut)
            let response = await this.$http.post('consimtamant/save', JSON.stringify(this.Continut))
            this.$message.success('Modificare realizata cu succes!');
        }
    },
    get_consimtamant: async function(){
      let res = await this.$http.post('consimtamant/getConsimtamant');
      this.Continut = res.body.Consimtamant.Html;
      await this.$nextTick();
    },
    get_consimtamant: async function () {
      let res = await this.$http.post("consimtamant/getConsimtamant");
      this.Continut = res.body.Consimtamant.Html;
      await this.$nextTick();
    },
    async get_info() {
      this.get_consimtamant();
      this.refresh_info();
    },

    async refresh_info() {
      this.select_menu_item("consimtamant");
    },
  },
  mounted() {
    if (!this.$has_right("Management")) {
      this.$router.push("/no-rights");
      return;
    }
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.tag-logged {
  font-size: 12px;
  opacity: 0.5;
}

.editor {
  background-color: #fff;
  padding: 10px;
  height: 100%;
}

.btn-group {
  margin: 10px;
}
</style>
